import React, { useCallback, useEffect, useState } from 'react';

import * as stampcardStorage from '../lib/storage/stampcard';

type Stampcard = stampcardStorage.Stampcard;

type StampCardContextProps = {
  // Nav defines the user's nav
  stampcard: Stampcard | null;
  // setNav sets a new nav in context and stores it in local storage
  setStampCard: (stampcard: Stampcard) => void;
  // removeNav removes the nav from context and local storage
  removeStampCard: () => void;
};

const StampCardContext = React.createContext<StampCardContextProps | null>(
  null
);

/**
 * NavContextProvider provides the nav context to it's children
 */
export function StampCardContextProvider({
  children,
}: React.PropsWithChildren<{}>) {
  const [stampcard, setStampCardState] = useState(stampcardStorage.get());

  // Persist the token to local storage when the token changes. Remove the token
  // if it is null.
  useEffect(() => {
    if (stampcard) {
      stampcardStorage.set(stampcard);
    } else {
      stampcardStorage.remove();
    }
  }, [stampcard]);

  const removeStampCard = useCallback(() => {
    setStampCardState(null);
  }, []);

  const setStampCard = useCallback((s) => {
    setStampCardState(s);
  }, []);

  const ctx = {
    stampcard,
    setStampCard,
    removeStampCard,
  };

  return (
    <StampCardContext.Provider value={ctx}>
      {children}
    </StampCardContext.Provider>
  );
}

export default StampCardContext;
